"use client";
import { SimpleGrid, Flex, Stack, Box } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { Heading, Text, Button } from "@/elements";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { APPS_CONSTANTS } from "./constants";
import { MAIN_ROUTES, APPS_ROUTES } from "@/constants/routes";

const AppsCards = () => {
  const { apps, title, description } = APPS_CONSTANTS;
  const headingVariant = useHeadingVariant();
  const textVariant = useTextVariant();
  // const cardBg = useColorModeValue("white", "gray.800");
  // const cardBorder = useColorModeValue("gray.200", "gray.700");
  // const cardHover = useColorModeValue("gray.100", "gray.700");

  const cardBg = "white";
  const cardBorder = "gray.200";
  const cardHover = "gray.100";

  const [showAll, setShowAll] = useState(false);
  const displayedApps = showAll ? apps : apps.slice(0, 15);

  return (
    <Stack id="app-space" maxW="7xl" mx="auto" p={6} gap={8}>
      <Heading variant={headingVariant} textAlign="center">
        {title}
      </Heading>
      <Text variant={textVariant} textAlign="center" color="text.100">
        {description}
      </Text>

      <Box position="relative">
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} gap={10}>
          {displayedApps.map((app) => (
            <Flex
              key={app.name}
              bg={cardBg}
              className="brand-shadow"
              direction="column"
              alignItems="center"
              p={6}
              gap={2}
              border="1px solid"
              borderColor={cardBorder}
              borderRadius="2xl"
              overflow="hidden"
              transition="all 0.25s ease"
              _hover={{
                transform: "translateY(-5px)",
                shadow: "xl",
                bg: cardHover,
              }}
            >
              <Flex
                justify="center"
                mb={4}
                width="120px"
                height="120px"
                position="relative"
              >
                <Image
                  src={app.image}
                  alt={app.name}
                  fill
                  style={{ objectFit: "contain" }}
                  loading="lazy"
                />
              </Flex>
              <Text variant={"body1"} fontWeight={600}>
                {app.name}
              </Text>
              <Text mb={6} color="text.100" textAlign="center" variant={"body3"}>
                {app.description}
              </Text>
              <Button
                as={Link}
                href={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.MARKETPLACE_APPS}/${app.slug}`}
                variant={"ideal"}
              >
                Explore More
              </Button>
            </Flex>
          ))}
        </SimpleGrid>

        {/* Blurred overlay and button */}
        {!showAll && apps.length > 15 && (
          <Box
            position="absolute"
            bottom="0"
            left="0"
            w="100%"
            h="350px"
            bg="linear-gradient(to top, rgba(0, 0, 0, 0.1) 30%, transparent 80%)"
            backdropFilter="blur(10px)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderBottomRadius="2xl"
            zIndex="1"
          >
            <Button onClick={() => setShowAll(true)} colorScheme="teal" zIndex="2">
              See All Apps
            </Button>
          </Box>
        )}
      </Box>

      {/* View Less Button */}
      {showAll && (
        <Flex justify="center">
          <Button onClick={() => setShowAll(false)} variant={"ideal"}>
            View Less
          </Button>
        </Flex>
      )}
    </Stack>
  );
};

export default AppsCards;
